import { fetch } from 'containers/ClanManagement/proxy/helpers'

export const CLAN_INVITES_REQUEST_SUCCESS = 'CLAN_INVITES_REQUEST_SUCCESS'
export const CLAN_INVITES_REQUEST_ERROR = 'CLAN_INVITES_REQUEST_ERROR'
export const CLAN_INVITES_CHECKED = 'CLAN_INVITES_CHECKED'

export const clanInvitesRequestSuccess = (data) => ({
    type: CLAN_INVITES_REQUEST_SUCCESS,
    payload: {
        total: data.total,
    },
})

export const clanInvitesRequestError = (errorData) => ({
    type: CLAN_INVITES_REQUEST_ERROR,
    payload: errorData,
})

export const clanInvitesChecked = () => ({
    type: CLAN_INVITES_CHECKED,
})

export function requestClanInvites() {
    return async (dispatch) => {
        try {
            const url = `${window.config.WGCG_API_URL}/my/invites/?only_total=true&statuses=active`

            const response = await fetch(url, {
                method: 'GET',
                credentials: 'include',
            })
            dispatch(clanInvitesRequestSuccess(response))
        } catch (errorData) {
            dispatch(clanInvitesRequestError(errorData))
        }
    }
}


// WEBPACK FOOTER //
// ./state/actions/clan_invites.js